module.exports = __webpack_public_path__ + "static/media/camera3.6e946d40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/camera3.svg
// module id = 2529
// module chunks = 7